module.exports = __webpack_public_path__ + "img/urn-black.6c29c775.svg";